import Select from 'components/ui/Select';
import Card from 'components/ui/Card';
import { Graph } from 'assets/icons/revamp';
import { IMPACT_MEASUREMENT_OPTIONS } from 'constants/general';
import { t } from 'services/i18n.service';
import { useAppDispatch, useAppSelectorShallow } from 'store/hooks';
import { updateMoreOptionImpactCategory } from 'store/reducer/modal/slice';
import { moreOptionModalActivitySelector } from 'store/reducer/modal/more-options.modal.selectors';

const ImpactMeasurement: React.FC = () => {
  const dispatch = useAppDispatch();
  const activity = useAppSelectorShallow(moreOptionModalActivitySelector);

  return (
    <Card className='flex flex-col ~gap-3/4'>
      <div className='flex items-center ~gap-2/3'>
        <Graph
          className='~w-3/3.5 ~h-3/3.5 flex-shrink-0 text-primary-500 dark:text-primary-dark-500'
          fill='currentColor'
          fillDarkMode='currentColor'
        />
        <h3 className='~text-xs/base font-semibold text-black dark:text-white'>
          {t('impact_measurement.impact_category')}
        </h3>
      </div>
      <Select
        options={IMPACT_MEASUREMENT_OPTIONS.map(({ label, value }) => ({
          label: t(label),
          value
        }))}
        value={activity?.impact_category ?? undefined}
        onChange={(value) => {
          if (value) {
            dispatch(updateMoreOptionImpactCategory(value));
          }
        }}
        size='sm'
        variant='filled'
        isFullWidth
        className='w-full'
        placeholder={t('impact_measurement.impact_category')}
      />
    </Card>
  );
};

export default ImpactMeasurement;
